<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-data-table :headers="headers" :items="exam_list" dense class="elevation-1 mytable" :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Exam Bench Side</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row dense>
            <v-col sm="3" md="1" cols="4"> 
              <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile" small class="mt-1 ml-2">
                <v-icon left color="success">mdi-export</v-icon>
                Export
              </v-btn>
            </v-col>

            <v-row justify="center" dense>
              <v-col sm="6" md="6" cols="12">
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>

            </v-row>

          
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 mr-5 button" v-on="on" small>Add Exam Bench Side</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-icon color="error">*</v-icon>
                          <v-text-field v-model="editedItem.bench_name" persistent-hint :hint="
                              editedIndex == -1
                                ? 'For example :: L, R'
                                : 'For example :: L, R'
                            " label="Enter Bench Name" :rules="[(v) => !!v || 'required']" outlined>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-icon color="error">*</v-icon>
                          <v-text-field v-model="editedItem.sort_order" persistent-hint :hint="
                              editedIndex == -1
                                ? 'For example :: 1, 2, 3'
                                : 'For example :: 1, 2, 3'
                            " label="Enter Sort Order" outlined type="number" :rules="[(v) => !!v || 'required']">
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
             <v-avatar size="25" class="delete-avatar ml-2">
              <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
            </v-avatar>
          </div>
        </template>

            <template v-slot:item.isactive="{ item }">
                  <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)" dense></v-switch>
            </template>
            <template v-slot:item.sr_No="{ item }">
                {{ exam_list.indexOf(item) + 1 }}
            </template>


      </v-data-table>

      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {

  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    loader:false,
    errorMsg: {
      id: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text:"S.No",
        align:"left",
        sortable:"false",
        value: "sr_No",
      },
      {
        text: "Sort Order",
        align: "left",
        sortable: false,
        value: "sort_order",
      },
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "bench_name",
      },
      {
        text: "IsActive",
        align: "left",
        sortable:"false",
        value: "isactive"

      },
      { text: "Actions", value: "action", sortable: false },
    ],
    exam_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      sort_order: "",
      bench_name: "",
      isactive:"",
    },
    defaultItem: {
      id: "",
      sort_order: "",
      bench_name: "",
      isactive:"",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Bench" : "Edit Bench";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.room_number = false;
    },

    downloadFile() {
      this.loader = true;

      const excelData = this.exam_list.map((item, index) => ({
        "S.No": index + 1,
        "Sort Order": item.sort_order,
        "Name": item.bench_name,
        "Status": item.isactive ? "Active" : "Inactive"

      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Exam Bench Side List");
      XLSX.writeFile(workbook, "Exam Bench Side List.xlsx");

      this.loader = false;
    },

    onLoad() {
      this.overlay = true;
      axios
        .post("/SeatingArrangement/getExamBenchSide")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.exam_list = res.data.exam_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.exam_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/SeatingArrangement/editBenchSide", this.editedItem)
            .then((res) => {
              if (res.data.status == "YES") {
                Object.assign(
                  this.exam_list[this.editedIndex],
                  this.editedItem
                );
                this.onLoad();
                this.showSnackbar("#4caf50", "Bench Side Updated Successfully..."); // show snackbar on success
              } else if (res.data.status == "NA") {
                this.showSnackbar("#b71c1c", "Bench Side Already Present!!!"); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        axios
          .post("/SeatingArrangement/saveBenchSide", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.exam_list.push(this.editedItem);
              this.onLoad();
              this.showSnackbar("#4caf50", "Bench Side Added Successfully..."); // show snackbar on success
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Bench Side Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.bench_name && this.editedItem.sort_order) {
        return true;
      } else {
         console.log("inside ============");
        if (!this.editedItem.bench_name && !this.editedItem.sort_order) {
          this.errorMsg.bench_name = true;
        }
        return false;
      }
    }, // .....end of isValidated()
     toggle(item) {
      const data = {
        id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/SeatingArrangement/toggleBench", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Bench Side Updated!");
            this.onLoad();
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#4caf50",
              "Something went wrong, Please try again later!"
            );
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    deleteItem(item) {
      if(confirm("Are You Sure You Want to Delete")){
      {
      const data = {
        id: item.id,
      };
      this.overlay = true;
      axios
        .post("/SeatingArrangement/deleteBench", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.onLoad();
            this.showSnackbar("#4caf50", "Bench Side Deleted!");
          } else if (res.data.code == "NA") {
            this.showSnackbar( "#b71c1c",res.data.msg || "Something went wrong, Please try again later!");
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
      }
    }
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>